<template>
  <div style="background:rgba(0,0,0,0.5);position: absolute;width:100%;">
    <div style="z-index: 9;position: relative;top: 0;">
      <div class="width-main">
        <div class="flexHeader">
          <div class="logo" >
            <img style="width:110px;" @click="goHome()" src="../../assets/logo.png"/>
          </div>
          <div>
            <div style="position: relative;top: 20px;">
              <LoginTag />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginTag from '@comm/components/LoginTag.vue'
export default {
  name: 'headers',
  components: {
    LoginTag
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    goHome () {
      this.$router.push('/Match')
    }
  }
}
</script>
<style lang="scss" scoped>
.flexHeader {
  display: flex;
  justify-content: space-between;
  z-index: 20;
  .logo {
    color: #fff;
    cursor: pointer;
  }
  .menu {
    display: flex;
    div {
      margin: 0 10px;
      padding: 18px 20px;
      color: #fff;
      cursor: pointer;
      font-size: 0.9rem;
      border-bottom: 2px solid transparent;
      text-align: center;
    }
    .menu-hover:hover{
      border-bottom: 2px solid red;
    }
    .current {
      border-bottom: 2px solid white;
    }
  }
  .ant-dropdown-link {
    color: #fff;
  }
}
.width-main {
  width: 1200px;
  margin: 0 auto;
}
.bg {
  background-color: rgb(247, 247, 247);
}
.mr18 {
  margin-right: 18px;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/layout/MatchHeader.vue